<!-- <app-sidebar
  [isLeftSidebarCollapsed]="isLeftSidebarCollapsed()"
  (changeIsLeftSidebarCollapsed)="changeIsLeftSidebarCollapsed($event)"
></app-sidebar>


<main class="body flex flex-col h-screen" [ngClass]="screenClass()">
  <app-header ></app-header>


  <div class="flex-1 p-2 overflow-auto bg-background">
    <router-outlet></router-outlet>
  </div>
</main> -->

<app-sidebar
  class="hidden lg:block"
  [isLeftSidebarCollapsed]="isLeftSidebarCollapsed()"
  (changeIsLeftSidebarCollapsed)="changeIsLeftSidebarCollapsed($event)"
></app-sidebar>

<main
  class="flex flex-col h-screen transition-all duration-300"
  [ngClass]="{
    'lg:ml-[5rem]': isLeftSidebarCollapsed(),
    'lg:ml-[16.5625rem]': !isLeftSidebarCollapsed(),
  }"
>
  <app-header   class="sticky top-0 z-50"></app-header>

  <div  class="flex-1 p-2  bg-background">
    <router-outlet></router-outlet>
  </div>
</main>
